import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Skeleton } from 'components/shared/AntComponent';
import { Button, Select } from 'components/shared/FormComponent';
import { LoadingOutlined, SyncOutlined } from 'components/shared/AntIcons';
import { ApexOptions } from 'apexcharts';
import Chart from 'react-apexcharts';
import { getDashboard, getDashUpcomingExam,getDashCardCount,getUnattendedExamList,getDashboardGraph, getCurrentMonthExams } from 'services/store/actions/dashboardAction';
import { dashboardExamList, getExamDetails } from 'services/store/actions/examAction';
import InterviewIcon   from 'assets/icons/interview-user.svg';
import InternBatchIcon from 'assets/icons/intern-batch-icon.svg';
import InternProjIcon  from 'assets/icons/intern-project-icon.svg';
import InternIcon      from 'assets/icons/graduate-icon.svg';
import dayjs from 'dayjs';
import 'assets/styles/dashboard.scss';



interface ExamEntry {
  id:          number;
  examID:      number;
  examName:    string;
  examDate:    string;
  start_time:  string;
  end_time:    string;
  examcode:    string;
  status:      'live' | 'upcoming' | 'completed';
  registered:  number;
  loggedIn:    number;
  attended:    number;
  absent:      number;
}

interface UnattendedStudent {
  id:         number;
  name:       string;
  rollNo:     string;
  department: string;
  email:      string;
}

interface LiveStats {
  registered: number;
  loggedIn:   number;
  attended:   number;
  absent:     number;
}


const SIDEBAR_COLORS = [
  '#5ca8e6','#f7b950','#8ad15e','#ba80d0',
  '#f87171','#34d399','#60a5fa','#c084fc',
  '#fbbf24','#6ee7b7','#93c5fd','#d8b4fe',
];

const STATUS_META = {
  live:      { label: 'LIVE',     color: '#ef4444', bg: '#fef2f2' },
  upcoming:  { label: 'UPCOMING', color: '#f97316', bg: '#fff7ed' },
  completed: { label: 'DONE',     color: '#10b981', bg: '#ecfdf5' },
} as const;


const sidebarExams: ExamEntry[] = [
  { id: 1,  examID: 101, examName: 'React Fundamentals',         examDate: '2025-03-03', start_time: '09:00 AM', end_time: '11:00 AM', examcode: 'RF-101',  status: 'completed', registered: 120, loggedIn: 98,  attended: 90,  absent: 30  },
  { id: 2,  examID: 102, examName: 'Node.js Advanced',           examDate: '2025-03-05', start_time: '10:00 AM', end_time: '12:30 PM', examcode: 'NA-102',  status: 'completed', registered: 85,  loggedIn: 72,  attended: 68,  absent: 17  },
  { id: 3,  examID: 103, examName: 'TypeScript Basics',          examDate: '2025-03-08', start_time: '02:00 PM', end_time: '04:00 PM', examcode: 'TS-103',  status: 'completed', registered: 60,  loggedIn: 55,  attended: 50,  absent: 10  },
  { id: 4,  examID: 104, examName: 'AWS Cloud Practitioner',     examDate: '2025-03-10', start_time: '09:30 AM', end_time: '12:00 PM', examcode: 'AWS-104', status: 'live',      registered: 200, loggedIn: 143, attended: 110, absent: 90  },
  { id: 5,  examID: 105, examName: 'Python Data Science',        examDate: '2025-03-12', start_time: '11:00 AM', end_time: '01:00 PM', examcode: 'PY-105',  status: 'upcoming',  registered: 95,  loggedIn: 0,   attended: 0,   absent: 0   },
  { id: 6,  examID: 106, examName: 'Docker & Kubernetes',        examDate: '2025-03-14', start_time: '03:00 PM', end_time: '05:30 PM', examcode: 'DK-106',  status: 'upcoming',  registered: 75,  loggedIn: 0,   attended: 0,   absent: 0   },
  { id: 7,  examID: 107, examName: 'GraphQL Mastery',            examDate: '2025-03-17', start_time: '10:00 AM', end_time: '12:00 PM', examcode: 'GQ-107',  status: 'upcoming',  registered: 50,  loggedIn: 0,   attended: 0,   absent: 0   },
  { id: 8,  examID: 108, examName: 'System Design Interview',    examDate: '2025-03-19', start_time: '02:30 PM', end_time: '05:00 PM', examcode: 'SD-108',  status: 'upcoming',  registered: 140, loggedIn: 0,   attended: 0,   absent: 0   },
  { id: 9,  examID: 109, examName: 'SQL & Database Design',      examDate: '2025-03-21', start_time: '09:00 AM', end_time: '11:30 AM', examcode: 'SQ-109',  status: 'upcoming',  registered: 110, loggedIn: 0,   attended: 0,   absent: 0   },
  { id: 10, examID: 110, examName: 'DevOps Practices',           examDate: '2025-03-24', start_time: '01:00 PM', end_time: '03:00 PM', examcode: 'DO-110',  status: 'upcoming',  registered: 88,  loggedIn: 0,   attended: 0,   absent: 0   },
  { id: 11, examID: 111, examName: 'Machine Learning Basics',    examDate: '2025-03-26', start_time: '10:30 AM', end_time: '01:00 PM', examcode: 'ML-111',  status: 'upcoming',  registered: 130, loggedIn: 0,   attended: 0,   absent: 0   },
  { id: 12, examID: 112, examName: 'Microservices Architecture', examDate: '2025-03-28', start_time: '03:00 PM', end_time: '05:00 PM', examcode: 'MA-112',  status: 'upcoming',  registered: 70,  loggedIn: 0,   attended: 0,   absent: 0   },
];




const DEPT_COLORS: Record<string, { bg: string; color: string; border: string }> = {
  EEE:  { bg: '#fef9c3', color: '#854d0e', border: '#fef08a' },
  ECE:  { bg: '#dbeafe', color: '#1e40af', border: '#bfdbfe' },
  CSE:  { bg: '#dcfce7', color: '#166534', border: '#bbf7d0' },
  MECH: { bg: '#ffe4e6', color: '#9f1239', border: '#fecdd3' },
  IT:   { bg: '#f3e8ff', color: '#6b21a8', border: '#e9d5ff' },
  CIVIL:{ bg: '#ffedd5', color: '#9a3412', border: '#fed7aa' },
};
const DEPT_DEFAULT = { bg: '#f1f5f9', color: '#475569', border: '#e2e8f0' };


function makeBarOptions(categories: string[]): ApexOptions {
  return {
    colors: ['#f97316'],
    chart: {
      type: 'bar',
      toolbar:    { show: false },
      zoom:       { enabled: false },
      background: 'transparent',
      animations: { enabled: true },
    },
    dataLabels: { enabled: false },
    plotOptions: { bar: { borderRadius: 5, columnWidth: '58%' } },
    grid: { show: false },
    yaxis: { labels: { show: false } },
    xaxis: {
      categories,
      labels: {
        style: { fontFamily: 'DM Sans, sans-serif', fontSize: '10px', colors: '#94a3b8' },
      },
      axisBorder: { show: false },
      axisTicks:  { show: false },
    },
   tooltip: {
  theme: "light",
  y: {
    formatter: (val: number) => `Exams : ${val}`
  }
},
  };
}



const AnimatedNumber: React.FC<{ value: number; accentColor: string }> = ({ value, accentColor }) => {
  const [display, setDisplay] = useState(value);
  const [flashing, setFlashing] = useState(false);
  const prevValue = useRef(value);
  
  const frameId   = useRef(0);

  useEffect(() => {
    if (prevValue.current === value) return;

    const from = prevValue.current;
    const duration = Math.min(700, Math.abs(value - from) * 25);
    const startTime = performance.now();

    cancelAnimationFrame(frameId.current);

    const tick = (now: number) => {
      const progress = Math.min((now - startTime) / duration, 1);
      const eased    = 1 - Math.pow(1 - progress, 3); 
      setDisplay(Math.round(from + (value - from) * eased));

      if (progress < 1) {
        frameId.current = requestAnimationFrame(tick);
      } else {
        setDisplay(value);
        prevValue.current = value;
      }
    };

    frameId.current = requestAnimationFrame(tick);
    setFlashing(true);
    const timer = setTimeout(() => setFlashing(false), 900);

    return () => {
      cancelAnimationFrame(frameId.current);
      clearTimeout(timer);
    };
  }, [value]);

  return (
    <span style={{ color: flashing ? accentColor : undefined }}>
      {display.toLocaleString()}
    </span>
  );
};

const LiveBadge: React.FC = () => (
  <span className="db-live-badge">
    <span className="db-live-dot" />
    LIVE
  </span>
);

interface ExamItemProps {
  item:       ExamEntry;
  colorIndex: number;
  isSelected: boolean;
  onSelect:   (id: number) => void;
}

const ExamItem: React.FC<ExamItemProps> = ({ item, colorIndex, isSelected, onSelect }) => {
  const sm = STATUS_META[item.status] ?? STATUS_META.upcoming;

  return (
    <div
      className={`db-ei${isSelected ? ' is-selected' : ''}`}
      style={{ '--ei-color': SIDEBAR_COLORS[colorIndex % SIDEBAR_COLORS.length] } as React.CSSProperties}
      onClick={() => onSelect(item.examID)}
    >
      <div className="db-ei-top">
        <span className="db-ei-name">{item.examName}</span>
        <span className="db-ei-code">{item.examcode}</span>
      </div>
      <div className="db-ei-row2">
        <div className="db-ei-meta">
          <span>📅 {dayjs(item.examDate).format('MMM DD')}</span>
          <span>🕐 {item.start_time}</span>
          <div className="db-ei-reg">· 👥 <strong>{item.registered}</strong></div>
        </div>
        <span
          className="db-status"
          style={{ color: sm.color, background: sm.bg }}
        >
          {item.status === 'live' && <span className="db-status-dot" />}
          {sm.label}
        </span>
      </div>
    </div>
  );
};


const PAGE_SIZE = 10;

const UnattendedList: React.FC<{
  students:        UnattendedStudent[];
  loading:         boolean;
  selectedExamID:  number | null;
}> = ({ students, loading, selectedExamID }) => {
  const [search,     setSearch]     = useState('');
  const [activeDept, setActiveDept] = useState<string>('ALL');
  const [page,       setPage]       = useState(1);

  useEffect(() => { setPage(1); }, [selectedExamID, activeDept, search]);

const depts = ['ALL', ...Array.from(new Set(students.map(s => s.department))).sort()];

  const filtered = students.filter(s => {
    const matchDept   = activeDept === 'ALL' || s.department === activeDept;
    const matchSearch = search === '' ||
      s.name.toLowerCase().includes(search.toLowerCase()) ||
      s.rollNo.toLowerCase().includes(search.toLowerCase()) ||
      s.email.toLowerCase().includes(search.toLowerCase());
    return matchDept && matchSearch;
  });

  const totalPages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
  const safePage   = Math.min(page, totalPages);
  const pageRows   = filtered.slice((safePage - 1) * PAGE_SIZE, safePage * PAGE_SIZE);

  const fillerCount = PAGE_SIZE - pageRows.length;

  if (loading) return <Skeleton active paragraph={{ rows: 8 }} />;

  return (
    <div className="ua-root">

      <div className="ua-toolbar">
        <input
          className="ua-search"
          placeholder="Search name, roll no or email…"
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
        <div className="ua-dept-filters">
          {depts.map(d => {
            const dc       = d !== 'ALL' ? (DEPT_COLORS[d] ?? DEPT_DEFAULT) : null;
            const isActive = activeDept === d;
            return (
              <button
                key={d}
                className={`ua-dept-btn${isActive ? ' active' : ''}`}
                style={isActive && dc
                  ? { background: dc.bg, color: dc.color, borderColor: dc.border } as React.CSSProperties
                  : undefined}
                onClick={() => setActiveDept(d)}
              >
                {d}
                {d !== 'ALL' && (
                  <span className="ua-dept-pill-count">
                    {students.filter(s => s.department === d).length}
                  </span>
                )}
              </button>
            );
          })}
        </div>
      </div>

      <div className="ua-table-wrap">

        <div className="ua-thead">
          <div className="ua-th ua-col-idx">#</div>
          <div className="ua-th ua-col-name">Name</div>
          <div className="ua-th ua-col-roll">Roll No</div>
          <div className="ua-th ua-col-dept">Department</div>
          <div className="ua-th ua-col-email">Email</div>
        </div>

        <div className="ua-tbody">
          {filtered.length === 0 ? (
            <div className="ua-empty">
              <span>🎉</span>
              <p>
                {!selectedExamID
                  ? 'Select an exam from the dropdown to view unattended students.'
                  : search
                  ? 'No students match your search.'
                  : 'No unattended students for this exam.'}
              </p>
            </div>
          ) : (
            <>
              {pageRows.map((s, idx) => {
                const dc      = DEPT_COLORS[s.department] ?? DEPT_DEFAULT;
                const rowNum  = (safePage - 1) * PAGE_SIZE + idx + 1;
                return (
                  <div key={s.id} className={`ua-tr${idx % 2 === 1 ? ' ua-tr-alt' : ''}`}>
                    <div className="ua-td ua-col-idx">{rowNum}</div>
                    <div className="ua-td ua-col-name">
                      <div
                        className="ua-avatar"
                        style={{ '--av-bg': dc.bg, '--av-color': dc.color } as React.CSSProperties}
                      >
                        {s.name.charAt(0)}
                      </div>
                      <span className="ua-name">{s.name}</span>
                    </div>
                    <div className="ua-td ua-col-roll">{s.rollNo}</div>
                    <div className="ua-td ua-col-dept">
                      <span
                        className="ua-dept-tag"
                        style={{ background: dc.bg, color: dc.color, borderColor: dc.border } as React.CSSProperties}
                      >
                        {s.department}
                      </span>
                    </div>
                    <div className="ua-td ua-col-email">{s.email}</div>
                  </div>
                );
              })}

              {Array.from({ length: fillerCount }).map((_, i) => (
                <div key={`filler-${i}`} className="ua-tr ua-tr-filler" />
              ))}
            </>
          )}
        </div>

        <div className="ua-tfoot">
          <span className="ua-foot-info">
            {filtered.length === 0
              ? '0 students'
              : `${(safePage - 1) * PAGE_SIZE + 1}–${Math.min(safePage * PAGE_SIZE, filtered.length)} of ${filtered.length}`}
          </span>

          {totalPages > 1 && (
            <div className="ua-pagination">
              <button
                className="ua-pg-btn"
                disabled={safePage === 1}
                onClick={() => setPage(1)}
                title="First page"
              >«</button>
              <button
                className="ua-pg-btn"
                disabled={safePage === 1}
                onClick={() => setPage(p => Math.max(1, p - 1))}
                title="Previous"
              >‹</button>

              {Array.from({ length: totalPages }, (_, i) => i + 1)
                .filter(p => p === 1 || p === totalPages || Math.abs(p - safePage) <= 1)
                .reduce<(number | '…')[]>((acc, p, i, arr) => {
                  if (i > 0 && p - (arr[i - 1] as number) > 1) acc.push('…');
                  acc.push(p);
                  return acc;
                }, [])
                .map((p, i) =>
                  p === '…'
                    ? <span key={`ellipsis-${i}`} className="ua-pg-ellipsis">…</span>
                    : <button
                        key={p}
                        className={`ua-pg-btn ua-pg-num${safePage === p ? ' active' : ''}`}
                        onClick={() => setPage(p as number)}
                      >{p}</button>
                )
              }

              <button
                className="ua-pg-btn"
                disabled={safePage === totalPages}
                onClick={() => setPage(p => Math.min(totalPages, p + 1))}
                title="Next"
              >›</button>
              <button
                className="ua-pg-btn"
                disabled={safePage === totalPages}
                onClick={() => setPage(totalPages)}
                title="Last page"
              >»</button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

async function fetchLiveStats(examID: number): Promise<LiveStats | null> {
  await new Promise(r => setTimeout(r, 350)); 

  const base = sidebarExams.find(e => e.examID === examID);
  if (!base) return null;

  if (base.status !== 'live') {
    return { registered: base.registered, loggedIn: base.loggedIn, attended: base.attended, absent: base.absent };
  }

  return {
    registered: base.registered,
    loggedIn:   Math.min(base.registered, base.loggedIn  + Math.floor(Math.random() * 4)),
    attended:   Math.min(base.loggedIn,   base.attended  + Math.floor(Math.random() * 3)),
    absent:     Math.max(0, base.registered - base.attended - Math.floor(Math.random() * 4)),
  };
}


const Dashboard: React.FC = () => {
  const dispatch = useDispatch();

  const { dashInfo, loading2, dashCandidInfo, loading1, dashboardInfo, getDashCardCountInfo,getUnattendedExamListInfo,getDashboardGraphInfo, getCurrentMonthExamsInfo, getCurrentMonthExamsLoading } = useSelector((state: any) => state.dashboard);
  const { loading: examLoading, loading14, dashExamList , getExamDetailsInfo, getExamDetailsSuccess, getExamDetailsLoading } =     useSelector((state: any) => state.exam);
const registered = getDashCardCountInfo?.data?.registered || 0;
const attended = getDashCardCountInfo?.data?.attended || 0;
const loggedIn = getDashCardCountInfo?.data?.logIn || 0;
const currentMonthData = getCurrentMonthExamsInfo?.data || {};

const liveExamList = currentMonthData?.currentDateExamList || [];
const upcomingExamList = currentMonthData?.upComingExamList || [];
const completedExamList = currentMonthData?.completedExamList || [];
const unattended = registered - attended;
  const tenantID = localStorage.getItem('tenantID') ?? null;

  const [selectedExamID, setSelectedExamID] = useState<number | null>(null);
  const [liveStats,      setLiveStats]      = useState<LiveStats | null>(null);
  const [isLiveExam,     setIsLiveExam]     = useState(false);
  const [lastUpdatedAt,  setLastUpdatedAt]  = useState<Date | null>(null);
  const [changedStatKeys, setChangedStatKeys] = useState<Set<string>>(new Set());

  const prevStatsRef = useRef<LiveStats | null>(null);
  const isMountedRef = useRef(true);

  const graphData = getDashboardGraphInfo?.data || [];

const chartCategories = graphData.map((item: any) =>
  dayjs().month(item.month - 1).format("MMM")
);
const BAR_OPTIONS = makeBarOptions(chartCategories);

const chartCounts = graphData.map((item: any) => item.count);
const barSeries = [
  {
    name: "Exams",
    data: chartCounts
  }
];
  const [examVal, setExamVal] = useState(0);
const sidebarExams: ExamEntry[] = [
  ...liveExamList.map((e: any) => ({
    id: e.examID,
    examID: e.examID,
    examName: e.examName,
    examDate: e.examDate,
    start_time: "",
    end_time: "",
    examcode: e.examCode,
    status: "live",
    registered: 0,
    loggedIn: 0,
    attended: 0,
    absent: 0
  })),

  ...upcomingExamList.map((e: any) => ({
    id: e.examID,
    examID: e.examID,
    examName: e.examName,
    examDate: e.examDate,
    start_time: "",
    end_time: "",
    examcode: e.examCode,
    status: "upcoming",
    registered: 0,
    loggedIn: 0,
    attended: 0,
    absent: 0
  })),

  ...completedExamList.map((e: any) => ({
    id: e.examID,
    examID: e.examID,
    examName: e.examName,
    examDate: e.examDate,
    start_time: "",
    end_time: "",
    examcode: e.examCode,
    status: "completed",
    registered: 0,
    loggedIn: 0,
    attended: 0,
    absent: 0
  }))
];
const unattendedStudents: UnattendedStudent[] =
  getUnattendedExamListInfo?.data?.map((item: any) => ({
    id: item.candidateID,
    name: `${item.firstName} ${item.lastName}`,
    rollNo: item.regno,
department: item.specializationName?.toUpperCase().trim() || "N/A",
    email: item.email
  })) || [];

  

const examCount = graphData.reduce(
  (sum: number, item: any) => sum + (item.count || 0),
  0
);

const reportStart =
  graphData.length > 0
    ? dayjs()
        .year(graphData[0].year)
        .month(graphData[0].month - 1)
        .format("MMM YYYY")
    : "";

const reportEnd =
  graphData.length > 0
    ? dayjs()
        .year(graphData[graphData.length - 1].year)
        .month(graphData[graphData.length - 1].month - 1)
        .format("MMM YYYY")
    : "";

const REPORT_YEAR_RANGE = `${reportStart} - ${reportEnd}`;

const accOptions = [
  { label: "All Exam", value: 0 },
  ...(getExamDetailsInfo?.data?.map((acc: any) => ({
    label: acc?.examName,
    value: acc?.examID,
    key: acc?.examID,
  })) || [])
];
  const storeDropdownOptions = !loading14
    ? [...(dashExamList?.data ?? [])].reverse().map((acc: any) => ({
        label: `${acc.examName} — ${dayjs(new Date(acc.examDate)).format('MM/DD/YYYY')}`,
        value: acc.examID,
        key:   acc.id,
      }))
    : [];

  const examDropdownOptions = storeDropdownOptions.length > 0
    ? storeDropdownOptions
    : sidebarExams.map(e => ({
        label: `${e.examName} — ${dayjs(e.examDate).format('MM/DD/YYYY')}`,
        value: e.examID,
        key:   e.id,
      }));

  const displayStats = {
    registered: liveStats?.registered ?? dashInfo?.data?.total_register       ?? 0,
    loggedIn:   liveStats?.loggedIn   ?? dashInfo?.data?.total_total_failed    ?? 0,
    attended:   liveStats?.attended   ?? dashInfo?.data?.total_total_present   ?? 0,
    absent:     liveStats?.absent     ?? dashInfo?.data?.total_total_absent    ?? 0,
  };

const statCards = [
  {
    key: 'registered',
    label: 'Registered',
    value: registered,
    icon: InterviewIcon,
    accentColor: '#22c55e',
    bgColor: '#f0fdf4'
  },
  {
    key: 'loggedIn',
    label: 'Logged In',
    value: loggedIn,
    icon: InternProjIcon,
    accentColor: '#f97316',
    bgColor: '#fff7ed'
  },
  {
    key: 'attended',
    label: 'Attended',
    value: attended,
    icon: InternBatchIcon,
    accentColor: '#8b5cf6',
    bgColor: '#f5f3ff'
  },
  {
    key: 'absent',
    label: 'Unattended',
    value: unattended,
    icon: InternIcon,
    accentColor: '#3b82f6',
    bgColor: '#eff6ff'
  }
];

  const totalExams = sidebarExams.length;

      useEffect(() => {
  
      const inputJson = {
          ExamDate: dayjs().format("YYYY-MM-DD"),
          TenantId: Number(localStorage.getItem('tenantID')),
      };
  
      dispatch(getDashboardGraph(inputJson) as any);
  
  }, []);

      useEffect(() => {
  
      const inputJson = {
          StartDate: dayjs().format("YYYY-MM-DD"),
          TenantId: Number(localStorage.getItem('tenantID')),
      };
  
      dispatch(getCurrentMonthExams(inputJson) as any);
  
  }, []);

useEffect(() => {
    const tenantId = Number(localStorage.getItem('tenantID'));

    dispatch(getDashCardCount({
        id: examVal || 0,
        tenentId: tenantId
    }) as any);

    dispatch(getUnattendedExamList({
        id: examVal || 0,
        tenentId: tenantId
    }) as any);

}, []);

  const fetchOnce = useCallback(async (examID: number) => {
    if (!isMountedRef.current) return;
    try {
      const data = await fetchLiveStats(examID);
      if (!data || !isMountedRef.current) return;

      if (prevStatsRef.current) {
        const changed = new Set<string>(
          (Object.keys(data) as (keyof LiveStats)[]).filter(
            k => data[k] !== prevStatsRef.current![k]
          )
        );
        if (changed.size > 0) {
          setChangedStatKeys(changed);
          setTimeout(() => setChangedStatKeys(new Set()), 1000);
        }
      }

      prevStatsRef.current = data;
      setLiveStats({ ...data });
      setLastUpdatedAt(new Date());
    } catch { console.log('Failed to fetch live stats'); }
  }, []);

  useEffect(() => {
    isMountedRef.current = true;
    return () => { isMountedRef.current = false; };
  }, []);

const handleExamChange = (e: any) => {
    setExamVal(e);
    setSelectedExamID(e);

    const tenantId = Number(localStorage.getItem('tenantID'));

    // Card count API
    dispatch(getDashCardCount({
        id: e,
        tenentId: tenantId
    }) as any);

    // Unattended list API
    dispatch(getUnattendedExamList({
        id: e,
        tenentId: tenantId
    }) as any);
};

  const handleRefresh = useCallback(() => {
    if (selectedExamID) {
      getDashboard(selectedExamID);
      fetchOnce(selectedExamID);
    }
  }, [selectedExamID, fetchOnce]);

  useEffect(() => {
    if (!tenantID) return;
    dispatch(dashboardExamList(`0/${Number(tenantID)}`) as any);
    dispatch(getDashUpcomingExam(tenantID) as any);
  }, [tenantID]);

      useEffect(() => {
  
      const inputJson = {
          ExamID: 0,
          ExamDate: dayjs().format("YYYY-MM-DD"),
          TenantId: Number(localStorage.getItem('tenantID')),
      };
  
      dispatch(getExamDetails(inputJson) as any);
  
  }, []);

  return (
    <div className="db-root">

      <div className="db-hdr">
        <div>
          <div className="db-hdr-title">
            Exam Dashboard
            {isLiveExam && <LiveBadge />}
          </div>
          <p className="db-hdr-sub">Welcome back! Here&apos;s your live exam overview.</p>
          {lastUpdatedAt && (
            <div className="db-hdr-upd">
              ✓ Last refreshed · {dayjs(lastUpdatedAt).format('hh:mm:ss A')}
            </div>
          )}
        </div>

        <div className="db-hdr-right">
          <div className="db-sel">
            <Select
                                       showSearch
                                       options={accOptions}
                                       defaultValue={examVal}
                                       value={examVal}
                                       className='w-100'
                                       optionFilterProp="children"
                                       filterOption={(input: any, option: any) => {
                                           return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0 || option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                       }}
                                       filterSort={(optionA, optionB) => (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())}
                                       onChange={handleExamChange}
                                       notFoundContent={
                                           <div className="text-center p-4">
                                               { getExamDetailsLoading  ? (
                                                   <span>
                                                       <LoadingOutlined />
                                                       Loading...
                                                   </span>
                                               ) : (
                                                   <span>No exam found</span>
                                               )}
                                           </div>
                                       }
                                   />
          </div>
          <Button
            type="primary"
            className="db-btn"
            icon={loading2 ? <SyncOutlined spin /> : <SyncOutlined />}
            onClick={handleRefresh}
          >
            Refresh
          </Button>
        </div>
      </div>

      <div className="db-body">

        <div className="db-left">

          <div className="db-stats">
            {statCards.map(card => (
              <div
                key={card.key}
                className={`db-stat${changedStatKeys.has(card.key) ? ' is-changed' : ''}`}
                style={{
                  '--stat-accent': card.accentColor,
                  '--stat-bg':     card.bgColor,
                } as React.CSSProperties}
              >
                <div className="db-stat-ico">
                  <img src={card.icon} alt={card.label} />
                </div>
                <div>
                  <div className="db-stat-lbl">{card.label}</div>
                  <div className="db-stat-val">
                    {loading2 || loading14
                      ? <Skeleton.Button active size="small" />
                      : <AnimatedNumber value={card.value} accentColor={card.accentColor} />
                    }
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="db-rpt">
            <div className="db-rpt-info">
              <div className="db-rpt-ttl">Exam Report</div>
              <div className="db-yr-badge">{REPORT_YEAR_RANGE}</div>
              <div className="db-rpt-num">
                {getCurrentMonthExamsLoading ? <Skeleton.Button active size="small" /> : examCount}
              </div>
              <div className="db-rpt-sub">Exams conducted</div>
            </div>
            <div className="db-rpt-chart-wrap">
{!getDashboardGraphInfo?.data
  ? <Skeleton active style={{ marginTop: 16, padding: '0 12px' }} />
  : (
      <Chart
        options={BAR_OPTIONS}
        series={barSeries}
        type="bar"
        width="100%"
        height="148px"
      />
    )
}            </div>
          </div>

          <div className="db-analysis">
            <div className="db-analysis-hdr">
              <div className="db-sec-ttl">Unattended Students</div>
              <div className="db-sec-sub">
                {selectedExamID
                  ? `Showing unattended · ${examDropdownOptions.find(o => o.value === selectedExamID)?.label ?? ''}`
                  : 'Select an exam from the dropdown to view students'}
              </div>
            </div>
            <div className="db-chart-grow">
              <UnattendedList
                students={selectedExamID ? unattendedStudents : []}
                loading={loading2 && !!selectedExamID}
                selectedExamID={selectedExamID}
              />
            </div>
          </div>
        </div>

        <div className="db-sidebar">
          <div className="db-sb-top">
            <div className="db-sb-row">
              <h2 className="db-sb-title">This Month&apos;s Exams</h2>
            </div>
            <p className="db-sb-meta">
              {totalExams} exams · {dayjs().format('MMMM YYYY')}
            </p>
            <div className="db-sb-status-row">
              {(['live','upcoming','completed'] as const).map(s => {
                const count = sidebarExams.filter(e => e.status === s).length;
                const sm    = STATUS_META[s];
                return count > 0 ? (
                  <span
                    key={s}
                    className="db-sb-status-pill"
                    style={{ background: sm.bg, color: sm.color } as React.CSSProperties}
                  >
                    {s === 'live' && <span className="db-status-dot" />}
                    {count} {sm.label}
                  </span>
                ) : null;
              })}
            </div>
          </div>

          <div className="db-list">
            {getCurrentMonthExamsLoading ? (
              <Skeleton active paragraph={{ rows: 10 }} style={{ padding: '8px 4px' }} />
            ) : sidebarExams.length === 0 ? (
              <div className="db-empty">
                <div className="db-empty-icon">📋</div>
                <p>No exams scheduled this month</p>
              </div>
            ) : (
              (['live', 'upcoming', 'completed'] as const).map(status => {
                const group = sidebarExams.filter(e => e.status === status);
                if (group.length === 0) return null;
                const sm = STATUS_META[status];
                return (
                  <React.Fragment key={status}>
                    <div className="db-group-label" style={{ '--gl-color': sm.color } as React.CSSProperties}>
                      {status === 'live' && <span className="db-status-dot" />}
                      {sm.label}
                      <span className="db-group-count">{group.length}</span>
                    </div>
                    {group.map((item) => {
                      const globalIdx = sidebarExams.findIndex(e => e.examID === item.examID);
                      return (
                        <ExamItem
                          key={item.examID}
                          item={item}
                          colorIndex={globalIdx}
                          isSelected={selectedExamID === item.examID}
                          onSelect={handleExamChange}
                        />
                      );
                    })}
                  </React.Fragment>
                );
              })
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;